import { FC } from "react";

interface DeleteIconProps{
  fill?: string;
  rectFill?: string;
}

export const DeleteIcon: FC<DeleteIconProps> = ({fill = "none", rectFill = "white"}) => {
  return (
     <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
  >
    <path
      fill="#FF4B4B"
      d="M6.64 2.4h2.4a.4.4 0 0 1 .4.4v.8h-3.2v-.8a.4.4 0 0 1 .4-.4Zm3.6 1.2v-.8a1.2 1.2 0 0 0-1.2-1.2h-2.4a1.2 1.2 0 0 0-1.2 1.2v.8h-2.8a.4.4 0 0 0 0 .8h.43l.684 8.528A1.6 1.6 0 0 0 5.348 14.4h4.984a1.6 1.6 0 0 0 1.596-1.472L12.61 4.4h.43a.4.4 0 1 0 0-.8h-2.8Zm1.567.8-.677 8.464a.8.8 0 0 1-.798.736H5.348a.8.8 0 0 1-.797-.736L3.874 4.4h7.933Zm-5.99.8a.4.4 0 0 1 .423.376l.4 6.8a.4.4 0 0 1-.798.048l-.402-6.8a.4.4 0 0 1 .376-.424h.002Zm4.047 0a.4.4 0 0 1 .376.424l-.4 6.8a.4.4 0 1 1-.798-.048l.4-6.8a.4.4 0 0 1 .422-.376Zm-2.024 0a.4.4 0 0 1 .4.4v6.8a.4.4 0 1 1-.8 0V5.6a.4.4 0 0 1 .4-.4Z"
    />
  </svg>
  );
};
